import YatungButton from '@Src/_basic/components/YatungButton';
import YatungDivider from '@Src/_basic/components/YatungDivider';
import YatungFormInput from '@Src/_basic/components/YatungFormInput';
import YatungFormLabel from '@Src/_basic/components/YatungFormLabel';
import YatungFormSelect from '@Src/_basic/components/YatungFormSelect';
import { Options } from '@Src/_basic/components/YatungSelect';
import AddCircleFill from '@Src/_basic/icons/AddCircleFill';
import { InitialWeightUnitFormData } from '@Src/_basic/object/WeightUnitManageType';
import { Stack } from '@mui/material';
import { Field } from 'formik';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BottomMappingData from './components/BottomMappingData';

interface Props {
  types: Array<Options>;
  values: InitialWeightUnitFormData;
  avaliableOptions: Array<Options>;
  arrayHelpers: any;
  setFieldValue: any;
  isUnitDialog: boolean;
}
export default function CreateUnitField(props: Props) {
  const { t: i18T } = useTranslation();
  const { types, arrayHelpers, values, setFieldValue, isUnitDialog, avaliableOptions } = props;

  const refresh = () => {
    const name = '車';
    const typeId = 0;
    const intlUnits = [
      {
        intlUnitId: 0,
        intlUnitValue: 1000,
      },
    ];
    setFieldValue('name', name);
    setFieldValue('typeId', typeId);
    setFieldValue('intlUnits', intlUnits);
  };
  const handlePushData = () => {
    arrayHelpers.push({
      intlUnitId: 0,
      intlUnitValue: 0,
    });
  };
  useEffect(() => {
    if (isUnitDialog === false) {
      refresh();
    }
  }, [isUnitDialog]);
  return (
    <>
      <Stack direction={'row'} sx={{ my: 2 }}>
        <Stack direction={'row'} justifyContent={'flex-start'}>
          <YatungFormLabel
            label={i18T('APPLICATIONSMANAGEMENT.WEIGHTUNITMANAGE.UNIT_NAME')}
            sx={{ fontSize: 20, fontWeight: 900, alignItems: 'center' }}
          />
        </Stack>
        <Stack direction={'row'} justifyContent={'flex-start'} sx={{ ml: 2 }}>
          <Field
            id="name"
            name="name"
            type="text"
            label=""
            component={YatungFormInput}
            sx={{ width: '80%' }}
            required
          />
        </Stack>
      </Stack>
      <Stack direction={'row'} sx={{ my: 2 }}>
        <Stack direction={'row'} justifyContent={'flex-start'}>
          <YatungFormLabel
            label={i18T('APPLICATIONSMANAGEMENT.WEIGHTUNITMANAGE.RELATED_UNIT')}
            sx={{ fontSize: 20, fontWeight: 900, alignItems: 'center' }}
          />
        </Stack>
        <Stack direction={'row'} justifyContent={'flex-start'} sx={{ ml: 1 }}>
          <Field
            id="typeId"
            name="typeId"
            type="number"
            label=""
            component={YatungFormSelect}
            options={types}
            required
          />
        </Stack>
      </Stack>
      <Stack direction={'row'} justifyContent={'flex-end'} sx={{ mb: 2 }}>
        <YatungButton
          color="green"
          text={i18T('GLOBAL.CREATE')}
          startIcon={<AddCircleFill />}
          onClick={handlePushData}
          disabled={values.intlUnits.length > 4}
          sx={{
            fontSize: '20px',
            width: 90,
            alignSelf: 'center',
          }}
        />
      </Stack>
      <Stack direction={'column'} sx={{ border: '1px solid #6C708C', mt: 1, borderRadius: '8px', px: 4, pt: 1, pb: 5 }}>
        <Stack direction={'row'} spacing={2} sx={{ my: 2 }}>
          <YatungFormLabel
            label={i18T('APPLICATIONSMANAGEMENT.WEIGHTUNITMANAGE.NAME')}
            sx={{ color: '#BB5E00', fontSize: 20, fontWeight: 900 }}
          />
          <YatungFormLabel
            label={i18T('APPLICATIONSMANAGEMENT.WEIGHTUNITMANAGE.VALUE')}
            sx={{ color: '#BB5E00', fontSize: 20, fontWeight: 900 }}
          />
        </Stack>
        <YatungDivider borderStyle />
        {values.intlUnits.length > 0 &&
          values.intlUnits.map((intlUnit: any, index: number) => (
            <Stack key={index}>
              <BottomMappingData index={index} avaliableOptions={avaliableOptions} values={values} />
            </Stack>
          ))}
      </Stack>
    </>
  );
}
